import cn from 'bem-cn';

import { Stack } from '../../../../UI';

import { ChallengePrizeProps } from './ChallengePrize.types';
import './ChallengePrize.scss';

const b = cn('challenge-prize');

export const ChallengePrize = (props: ChallengePrizeProps) => {
    const { prize, last, isCharity } = props;
    const { place, image, text } = prize;

    const showPlace = Boolean(place?.trim().length);

    if (isCharity) {
        return (
            <Stack className={b({ charity: true })}>
                <p className={b('text')}>{text}</p>
                <img className={b('image')} src={image} alt="" />
            </Stack>
        );
    }

    if (last) {
        return (
            <Stack className={b({ last: true })}>
                <Stack spacing={12}>
                    {showPlace && <h3 className={b('title')}>{place}</h3>}
                    <p className={b('text')}>{text}</p>
                </Stack>
                <img className={b('image')} src={image} alt="" />
            </Stack>
        );
    }

    return (
        <Stack className={b()}>
            {showPlace && <h3 className={b('title')}>{place}</h3>}
            <img className={b('image')} src={image} alt="" />
            <p className={b('text')}>{text}</p>
        </Stack>
    );
};
